import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ListDeclarationsMlvService } from '../../services/list-declarations-mlv.service';
import { MatTableDataSource, MatPaginator, PageEvent, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { environment } from 'src/environments/environment';
import { CompteOperateurService } from 'src/app/shared/services/operateur/compte.operateur.service';

import * as XLSX from 'xlsx';
import { AngularCsv } from 'angular7-csv';
import { Router } from '@angular/router';
import { AbstractWSOutputVO } from 'src/app/commun/vo/AbstractWSOutputVO';
import { HistoriqueDUMVO } from 'src/app/shared/models/HistoriqueDUMVO';
import { FindHistoriqueDUMOutputVO } from 'src/app/shared/models/FindHistoriqueDUMOutputVO';
import { SourceDevice } from 'src/app/shared/models/SourceDevice';


@Component({
  selector: 'app-list-declarations-mlv',
  templateUrl: './list-declarations-mlv.component.html',
  styleUrls: ['./list-declarations-mlv.component.scss']
})
export class ListDeclarationsMlvComponent implements OnInit, AfterViewInit {
  dataSource = new MatTableDataSource();
  totalElements = 0;
  idInterne: any = -1;
  itemsPerPage = 10;
  currentPage = 0;
  loading = false;
  paginate = true;
  noSelectedRows = false;
  config = environment.LODING_CONFIG;
  date: Date;

  selectedCompteOpe: any;
  facilities: any;

  filters: any = { resultatSelectivite: '', codeSens: '', mlv: '' };

  displayedColumns = ['numDum', 'dateEnregistrement', 'valeurDumDeclaree', 'poidsNet', 'resultatSSelectivite', 'nombreArticle','MLVOuiNon', 'regime', 'bureau', 'codeDeclarant', 'action'];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private router: Router, private listDeclarationMlvService: ListDeclarationsMlvService,
    private compteOperateurService: CompteOperateurService, public dialog: MatDialog) {
    this.idInterne = sessionStorage.getItem('operateur');
    this.selectedCompteOpe = JSON.parse(sessionStorage.getItem('selectedCompteOpe'));
    this.facilities = JSON.parse(sessionStorage.getItem('facilities'));
    if (this.idInterne) {
      this.loadMore();
    }
  }

  ngOnInit() {
    this.date = new Date();
    this.date.setDate(this.date.getDate() - 1);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  search() {
    this.currentPage = 0;
    this.loadMore();
  }

  clear() {
    this.currentPage = 0;
    this.filters = { resultatSelectivite: '', codeSens: '', mlv: '' };
  }

  public getServerData(event?: PageEvent) {
    if (event.pageIndex > event.previousPageIndex) {
      this.currentPage += 1;
    } else {
      this.currentPage -= 1;
    }
    this.loadMore();
  }

  exportXls(): void {
    const headers: any = {
      numDum: 'Numéro DUM	', dateEnregistrement: 'Date enregistrement	',
      valeurDumDeclaree: 'Valeur DUM Declarée', poidsNet: 'Poids net(kg)', resultatSSelectivite: 'Résultat de sélectivité'
    };

    let renderedData: any;
    this.listDeclarationMlvService.getListDeclarationsMlv(this.idInterne, 0, 0, this.filters).subscribe(result => {
      if (result && result.dums) {
        renderedData = new MatTableDataSource(result.dums);
        renderedData.data.unshift(headers);
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(renderedData.data
          .map(({ numDum, dateEnregistrement, valeurDumDeclaree, poidsNet, resultatSSelectivite }) =>
            ({ numDum, dateEnregistrement, valeurDumDeclaree, poidsNet, resultatSSelectivite })), { skipHeader: true });
        const workbook: XLSX.WorkBook = {
          Sheets: { 'Mes déclarations ayant MLV': worksheet }
          , SheetNames: ['Mes déclarations ayant MLV']
        };
        XLSX.writeFile(workbook, 'Mes déclarations ayant MLV.xlsx');
      }
    });
  }

  exportCsv(): void {
    let renderedData: any;
    this.listDeclarationMlvService.getListDeclarationsMlv(this.idInterne, 0, 0, this.filters).subscribe(result => {
      if (result && result.dums) {
        renderedData = new MatTableDataSource(result.dums);
        const file = new AngularCsv(renderedData.data.map(
          ({ numDum, dateEnregistrement, valeurDumDeclaree, poidsNet, resultatSSelectivite }) =>
            ({ numDum, dateEnregistrement, valeurDumDeclaree, poidsNet, resultatSSelectivite }))
          , 'Mes déclarations ayant MLV', { fieldSeparator: ';' });
      }
    });
  }

  loadMore() {
    if (this.idInterne === -1) {
      this.router.navigate(['/login']);
    }
    this.loading = true;
    const offset = this.currentPage * this.itemsPerPage;
    this.listDeclarationMlvService.getListDeclarationsMlv(this.idInterne, this.itemsPerPage, offset, this.filters).subscribe(result => {
      if (result && result.dums) {
        this.noSelectedRows = false;
        if (offset === 0) {
          this.totalElements = result.totalElements;
        }
        this.dataSource = new MatTableDataSource(result.dums);
        if (this.currentPage === 0 && this.totalElements <= this.itemsPerPage) {
          this.paginate = false;
        } else {
          this.paginate = true;
        }
      } else {
        this.dataSource = new MatTableDataSource([]);
        this.noSelectedRows = true;
        this.paginate = false;
      }
      this.loading = false;
    });
  }

  getHistoriqueDum(numDum) {
    const dialogRef = this.dialog.open(PopupHistoriqueDum, { data: numDum });
  }
}

@Component({
  selector: 'popup-historique-dum',
  templateUrl: 'popup-historique-dum.html',
  styleUrls: ['./popup-historique-dum.scss']
})
export class PopupHistoriqueDum implements OnInit {

  resultVO: AbstractWSOutputVO = new AbstractWSOutputVO();
  displayedColumns: string[] = ['date', 'ver', 'intervention', 'etatResultat', 'commentaire'];
  listHistoriqueDum: HistoriqueDUMVO[] = [];
  dataSource = new MatTableDataSource();
  constructor(public dialogRef: MatDialogRef<PopupHistoriqueDum>, @Inject(MAT_DIALOG_DATA) public data: any, private listDeclarationMlvService: ListDeclarationsMlvService) { }
  ngOnInit() {

    this.initializeResultVO(new AbstractWSOutputVO());
    this.showLoding();

    let sourceDevice = SourceDevice.WEB;

    if (window.innerWidth < environment.MOBILE_BREAK_POINT) {
      sourceDevice = SourceDevice.MOBILE;
    }
    this.listDeclarationMlvService.getListHistoriqueDum(this.data, sourceDevice).subscribe(result => {
      this.initializeResultVO(result);

      if (result && result.historiqueDum) {
        this.dataSource = new MatTableDataSource(result.historiqueDum);
        this.hideLoding();
      }
      else {
        this.dataSource = new MatTableDataSource([]);
        this.hideLoding();
      }

    });
    this.hideLoding();
  }
  loading = false;

  validate() {

  }
  showLoding() {
    this.loading = true;
  }

  hideLoding() {
    this.loading = false;
  }
  initializeResultVO(obj: AbstractWSOutputVO) {
    if (obj != null) {
      this.resultVO = new AbstractWSOutputVO();
      this.resultVO.listInformationMsgs = obj.listInformationMsgs;
      this.resultVO.listErrorMsgs = obj.listErrorMsgs;
    }
    if (this.resultVO == null) {
      this.resultVO = new AbstractWSOutputVO();
    }
    if (this.resultVO.listErrorMsgs == null) {
      this.resultVO.listErrorMsgs = [];
    }
    if (this.resultVO.listInformationMsgs == null) {
      this.resultVO.listInformationMsgs = [];
    }
    if (this.resultVO.listInformationMsgs.length > 0 || this.resultVO.listErrorMsgs.length > 0) {
      window.scroll(0, 0);
    }
  }

}

